module.exports = __webpack_public_path__ + "img/phase3.f9ac5a8a.png";